import {IOsaEvent} from "../../models/osa/osa.interface";

export interface IOsaScanningState {
  data: Array<IOsaEvent>;
  isLoaded: boolean;
}

export const initialOsaScanningState:IOsaScanningState = {
  data: [],
  isLoaded: false
};

export interface IOsaState {
  reports: {
    scanning:IOsaScanningState;
  };
}
export const initialOsaState:IOsaState = {
  reports: {
    scanning:initialOsaScanningState
  }
};

